export default __webpack_public_path__ + "locales/sk/Settings.json?hash=31aedc3978dea910fa252802519ea46d";